import { render } from "./messageAppearDetail.vue?vue&type=template&id=1355dad2&scoped=true"
import script from "./messageAppearDetail.vue?vue&type=script&lang=js"
export * from "./messageAppearDetail.vue?vue&type=script&lang=js"

import "./messageAppearDetail.vue?vue&type=style&index=0&id=1355dad2&lang=scss&scoped=true"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1355dad2"]])

export default __exports__